import React, { Component } from "react";
import { navigate } from "@my-dld/utils/StoreUtils";
import Strings from "@my-dld/assets/strings";

class Username extends Component {
	render() {
		return (
			<>
				<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
					<div className="sso-left-panel username-change-wrapper">
						<div className="form-group username-change-title">
							<span className="username-change-title-icon"/>
							{ Strings.forgot_username }
						</div>
						<div className="form-group mb-4">
                                                <span>{ Strings.please_contact_support } <a
	                                                href="mailto:support@dubailand.gov.ae"
	                                                className="underline">support@dubailand.gov.ae</a></span>
						</div>
						<div className="form-group">
							<button
								className="btn btn_1 btn_style1 btn-block" onClick={ () => {
								navigate( "/login" );
							} }>{ Strings.login }
							</button>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default Username;
